var React = require('react');
var { connect, useSelector } = require('react-redux');
var { timeSinceNowString } = require('helpers');
var dayjs = require('../../utils/dayjsConfig');
var IrrigationMeter = require('IrrigationMeter');
var { withTranslation, useTranslation } = require('react-i18next');
var { calculateVolume, unitDisplayName, convert } = require('unitsManager');
var fieldManager = require('fieldManager');
const { useState, useEffect } = require('react');
var { isSupportingPlannerByWeeks } = require('@managers/fieldManager');

const IrrigationMeterDetailsContainer = (props) => {
  const [gauge, setGauge] = useState(null);
  const [shouldDisplayVolume, setShouldDisplayVolume] = useState(false);
  const [noNeedToIrrigateMessage, setNoNeedToIrrigateMessage] =
    useState(undefined);
  const [irrigationAmountMessage, setIrrigationAmountMessage] = useState('');
  const [irrigationVolumeMessage, setIrrigationVolumeMessage] = useState('0');
  const [stressLevel, setStressLevel] = useState(0);
  const [recommendation_date, setRecommendationDate] = useState('');
  const { t } = useTranslation();

  const selectedFarmingUnit = useSelector(
    (state) => state.distribution_data.selected_entities.farming_unit,
  );
  useEffect(() => {
    if (props.selectedField) {
      updateGauge(props.selectedField);
    }
  }, [props.loadHistoryStatus.status, props.selectedField, stressLevel]);

  const onMouseover = (e) => {
    setShouldDisplayVolume(true);
  };

  const onMouseout = (e) => {
    setShouldDisplayVolume(false);
  };

  const updateGauge = (field) => {
    let recommendation_amount = -1;
    let stress_level = -1;
    let accumulatedETc = -1;
    let recommendation_date = dayjs();
    let recommendationAmountVolume = -1;
    let accumulatedETcVolume = -1;
    let area = undefined;
    let fieldAreaConverted = undefined;
    let messageByStressLevel = 'Normal';

    if (field) {
      let fieldItems = fieldManager.getFieldItems(field);
      stress_level = fieldItems.stressDataItem.value;
      recommendation_amount = fieldItems.irrigationDataItem.value;
      recommendation_date = fieldItems.irrigationDataItem.date;
      accumulatedETc = fieldItems.accumulatedETc.value;
      messageByStressLevel =
        stress_level === -1
          ? 'Normal'
          : stress_level === 1
            ? 'Normal'
            : stressLevel < 0.2
              ? 'High'
              : stressLevel < 0.4
                ? 'Medium'
                : 'Normal';
      area = fieldManager.getFieldArea(field.geo_data.areas);
      fieldAreaConverted = convert(area, 'dunam', props.userData.area, 'area');
      recommendationAmountVolume = calculateVolume(
        fieldAreaConverted,
        props.userData['area'],
        recommendation_amount,
        props.userData['length'],
        props.userData['volume'],
      );
      accumulatedETcVolume = calculateVolume(
        fieldAreaConverted,
        props.userData['area'],
        accumulatedETc,
        props.userData['length'],
        props.userData['volume'],
      );
    }

    gauge?.updateMeterValue(stress_level);

    var volumeMessageObject = fieldManager.get_stress_message(
      stress_level,
      recommendationAmountVolume,
      accumulatedETcVolume,
      recommendation_date,
      unitDisplayName(props.userData['volume']),
    );
    var messageObject = fieldManager.get_stress_message(
      stress_level,
      recommendation_amount,
      accumulatedETc,
      recommendation_date,
      props.userData['length'],
    );

    let irrigationMessage = undefined;
    let irrigationVolumeMessage = undefined;
    let noNeedToIrrigateMessage = undefined;

    if (messageObject['irrigationAmountMessage'] === 'good') {
      noNeedToIrrigateMessage = (
        <div
          className='font-weight-bold text-blue-secondary font-weight-bold text-size-14 align-items-center d-flex'
          style={{
            lineHeight: '1',
            borderRadius: '6px',
            gap: '4px',
            inlineSize: 'max-content',
            height: '20px',
            padding: '3px 8px 3px 8px',
          }}
        >
          {'0 mm' + ' - ' + messageByStressLevel}{' '}
        </div>
      );
    } else if (messageObject['irrigationAmountMessage']) {
      irrigationMessage = messageObject['irrigationAmountMessage'];
      irrigationVolumeMessage = volumeMessageObject['irrigationAmountMessage'];
    }

    let timeAgo = timeSinceNowString(dayjs.unix(recommendation_date));

    if (irrigationMessage) {
      irrigationMessage = irrigationMessage + ' - ' + messageByStressLevel;
    }

    if (irrigationVolumeMessage) {
      irrigationVolumeMessage =
        irrigationVolumeMessage + ' - ' + messageByStressLevel;
    }

    setStressLevel(stress_level);
    setNoNeedToIrrigateMessage(noNeedToIrrigateMessage);
    setIrrigationAmountMessage(irrigationMessage);
    setIrrigationVolumeMessage(irrigationVolumeMessage);
    setRecommendationDate(timeAgo);
  };

  let recommendationElement = <div></div>;

  // Determine if any planner in the FU is by weeks. Skeleton FUs omit `fields`.
  let anyPlannerByWeeks = false;
  if (selectedFarmingUnit?.fields) {
    anyPlannerByWeeks = Object.values(selectedFarmingUnit.fields).some((f) =>
      isSupportingPlannerByWeeks(f),
    );
  }

  if (anyPlannerByWeeks && props.selectedField) {
    // Get stressMsg like in FieldsSelector.jsx
    const fieldItems = fieldManager.getFieldItems(props.selectedField);
    const stressMsg = fieldManager.get_stress_message(
      fieldItems.stressDataItem.value,
      fieldItems.irrigationDataItem.value,
      fieldItems.accumulatedETc.value,
      null,
      unitDisplayName(props.userData['length']),
      anyPlannerByWeeks,
    );
    let stressMainMsg = undefined;
    let textColor = 'text-blue-secondary';
    if (
      ['gauge_no_data_v2', 'no_recommendation_available'].includes(
        stressMsg.mainMessage,
      )
    ) {
      stressMainMsg = t('gauge_no_data_v2');
      textColor = 'text-grey71';
    } else {
      stressMainMsg = t(stressMsg.mainMessage);
    }

    recommendationElement = (
      <div className='align-self-center'>
        <div className='text-center'>
          <div
            style={{
              width: 72,
              height: 32,
              textAlign: 'center',
              paddingTop: '2px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
            }}
            className={`font-weight-bold font-weight-bold text-size-14 align-items-center justify-content-center flex-row d-flex w-100 ${textColor}`}
          >
            {stressMainMsg}
          </div>
        </div>
      </div>
    );
  } else if (noNeedToIrrigateMessage) {
    recommendationElement = (
      <div>
        <div className=' text-center '>
          <div className=''>{noNeedToIrrigateMessage}</div>
        </div>
      </div>
    );
  } else if (irrigationAmountMessage) {
    recommendationElement = (
      <div className='align-self-center'>
        <div className='text-center'>
          <div>
            <div
              className='font-weight-bold text-blue-secondary font-weight-bold text-size-14 align-items-center justify-content-center flex-row d-flex w-100'
              style={{
                lineHeight: '1',
                borderRadius: '5px',
                padding: '3px 8px 3px 8px',
                gap: '4px',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={onMouseover}
              onMouseLeave={onMouseout}
            >
              {shouldDisplayVolume
                ? irrigationVolumeMessage
                : irrigationAmountMessage}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    recommendationElement = (
      <div
        className='text-size-14 text-center text-grey71 font-weight-bold'
        style={{
          lineHeight: '17px',
          whiteSpace: 'nowrap',
        }}
      >
        {t('no_recommendation')}
      </div>
    );
  }

  return (
    <div
      className='d-flex justify-content-center align-items-center bg-white gaugeContainer'
      style={{
        borderRadius: '15px',
        width: '330px',
        minHeight: '52px',
        gap: '4px',
        padding: '8px 24px 8px 24px',
      }}
    >
      <div
        className='d-flex flex-column justify-content-center gaugeTitlesContainer flex-grow-1'
        style={{ minWidth: '160px', maxWidth: '180px', gap: '4px' }}
      >
        <div
          className='text-grey45 text-size-14'
          style={{ minHeight: '18px', lineHeight: '17px', width: '100%' }}
        >
          {anyPlannerByWeeks ? t('gauge_title_v3') : t('soil_water_deficit')}
        </div>
        {recommendation_date && stressLevel !== -1 && (
          <div
            className='text-grey71 text-size-12 text-truncate lastUpdatedGaugeText'
            style={{ height: '15px', lineHeight: '90%', width: '100%' }}
          >
            {t('updated') +
              ' ' +
              t(recommendation_date[1]).format(recommendation_date[0])}
          </div>
        )}
      </div>
      <div
        className='d-flex align-items-center flex-column'
        style={{ width: 'auto', height: 'auto', gap: '0px' }}
      >
        <div
          className='d-flex flex-column align-items-center justify-content-center flex-shrink-0'
          style={{ height: '40px' }}
        >
          <IrrigationMeter
            onRef={(ref) => setGauge(ref)}
            shouldDisplayInFieldDetails={true}
            anyPlannerByWeeks={anyPlannerByWeeks}
          />
        </div>
        <div
          className='d-flex align-items-center justify-content-center text-center flex-grow-1'
          style={{ height: '20px', minWidth: 72, gap: '4px' }}
        >
          {recommendationElement}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    selectedField: state.distribution_data.selected_entities.field,
    userData: state.authentication_data.user_data,
    loadHistoryStatus: state.distribution_data.field_load_history,
  };
};

const mapDispatchToProps = {};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(IrrigationMeterDetailsContainer));
